module.exports = __webpack_public_path__ + "img/阵列3.006a00e5.svg";